export const formatRequestAmount = (amount) => (
  `GH¢${(Number(amount) || 0).toLocaleString('en-GH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
);

export const splitRequestItems = (items = []) => ({
  services: items.filter((item) => item.type === 'service'),
  products: items.filter((item) => item.type === 'product'),
  unclassified: items.filter((item) => item.type !== 'service' && item.type !== 'product'),
});

export const normalizeRequestStatus = (status = '') => (
  status.toString().toLowerCase().replace(/[\s_-]/g, '')
);
